import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as momentTz from 'moment-timezone';

@Pipe({ name: 'formatTimezone', standalone: true })
export class FormatTimezonePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: string, timezone: string, format: string): string {
    if (!format) {
      format = 'LONG-DATE-WITH-TIME';
    }

    if (!value) {
      return '';
    }

    let timeFormat = '';

    this.translate.get(`FORMAT.${format}`).subscribe((res: string) => (timeFormat = res));

    if (!timezone || !momentTz.tz(value, timezone).tz())
    {
      timezone = momentTz.tz.guess();
    }

    const date = (momentTz.tz(value, timezone)).format(timeFormat);

    return date;
  }
}
